import moment from "moment";
import { useWorkflowStore } from "./workflowStore";

function VersionHeader({ workflowId, version }) {
  const workflow = useWorkflowStore((state) => state.workflows[workflowId]);
  const isProduction = workflow.productionVersionId === version.id;
  return (
    <div>
      <h2 className="text-lg font-bold mb-0">
        Version {version.version} {isProduction && <span className="text-green-500">Active</span>}
        <div className="text-sm text-gray-500">
          Created {moment(version.createdAt).format("MMMM Do YYYY h:mm a")}
          {version.updatedAt && version.updatedAt !== version.createdAt && <> • Updated {moment(version.updatedAt).format("MMMM Do YYYY h:mm a")}</>}
          {version.completedAt && <> • Completed {moment(version.completedAt).format("MMMM Do YYYY h:mm a")}</>}
        </div>
      </h2>
    </div>
  );
}

export default VersionHeader;
